import { createSelector } from 'reselect';
import { getStudioSlice } from './page';

export const getHomeCounts = createSelector([getStudioSlice], state => state.home?.counts);

export const getHomeCurrencies = createSelector([getStudioSlice], state => state.home?.currencies);
